<script setup lang="ts">
const model = defineModel<string>()
</script>

<template>
  <UiMaskInput v-model="model" mask="phone" type="tel" autocomplete="tel" />
</template>
